import script from "./ActivityCalendar.vue?vue&type=script&setup=true&lang=ts"
export * from "./ActivityCalendar.vue?vue&type=script&setup=true&lang=ts"

import "./ActivityCalendar.vue?vue&type=style&index=0&id=8a4da8d4&lang=scss&scoped=true"

import exportComponent from "/builds/frontend/linjie/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8a4da8d4"]])

export default __exports__